import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import classes from './PaymentProcessing.module.css'
import Modal from './Modal'
import Spinner from '../loaders/Spinner'

const WAIT_FOR_DELAY_DURATION = 10 * 1000 // 10 seconds

export function PaymentProcessing({ open = false, className, ...props }) {
    const [isDelayed, setIsDelayed] = useState(false)

    useEffect(() => {
        if (open) {
            setIsDelayed(false)
            let timeoutId = setTimeout(() => {
                if (open) setIsDelayed(true)
            }, WAIT_FOR_DELAY_DURATION)
            return () => clearTimeout(timeoutId)
        }
    }, [open])

    return (
        <Modal
            open={open}
            allowDismiss={false}
            className={classNames(classes.paymentProcessingModal, className)}
            {...props}
        >
            <Spinner className={classes.spinner} />
            <h4 className={classes.title}>Processing your payment</h4>
            <p className={classes.subtitle}>
                Please do not close this browser window.
            </p>
            {isDelayed && (
                <p className={classes.subtitle}>
                    Seems like processing your payment is taking a while. Please
                    be patient.
                </p>
            )}
        </Modal>
    )
}
